export default {
  'TASK' (state) {
    return state.task
  },
  'TASKS' (state) {
    return state.tasks
  },
  'CONTACTS' (state) {
    return state.contacts
  }
}
